export const setTokenExpiredToStorage = () => {
  localStorage.setItem('tokenExpired', 'true');
};
